import MonixModal from "@/global/components/monix-modal";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import { useParams } from "react-router-dom";
import TnMessage from "@/global/components/message";
import { User } from "@/global/interface/project-manage/user";
import { getUsers } from "@/api/lib/user";

interface IProps {
    filterItems: User[]
    visible: boolean
    setVisible: (value: boolean) => void
    onFinish: (values: number[]) => void
    loading: boolean
}

export default function LinkProjectUserModal(props: IProps) {
    const [users, setUsers] = useState<User[]>([]); // 可选中的用户
    const [selected, setSelected] = useState<number[]>([]); // 选中的用户id
    const [loading, setLoading] = useState<boolean>(false); // 加载loading

    useEffect(() => {
        if (!props.visible) {
            setSelected([]);
            setLoading(false);
            setUsers([]);
        }
    }, [props.visible])

    // 初始化
    useEffect(() => {
        generateData();
    }, [])

    // 按下确认按钮
    const onSaveClick = () => {
        if (selected?.length === 0) {
            props.setVisible(false);
            return;
        }
        if (props?.onFinish) {
            props.onFinish(selected);
        }
    }

    // 获取可选择数据
    const generateData = () => {
        // TODO
        setLoading(true);
        getUsers().then(res => {
            if (res.status === 200) {
                let data: User[] = res.data || [];
                if (props?.filterItems) {
                    data = data?.filter(item => !props?.filterItems?.some(i => i.id === item.id)) || [];
                }
                setUsers(data);
            }
        }).catch(err => {
            TnMessage.error("获取用户失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"添加项目用户"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            onSaveClick={onSaveClick}
            wrapClassName="link-global-device-modal"
            saveDisable={props.loading}
        >
            <Spin wrapperClassName="link-global-device-body" spinning={loading}>
                <div className="link-body">
                    {users?.map((item: User, key) => (
                        <div className="link-item" key={key}>
                            <div className="item-icon" onClick={() => {
                                let idx = selected?.findIndex(g => g === item.id);
                                setSelected(prev => {
                                    if (idx === -1) {
                                        prev.push(item.id);
                                    } else {
                                        prev.splice(idx, 1);
                                    }
                                    return [...prev];
                                })
                            }}>
                                {!selected?.some(g => g === item.id) && <CheckSvg />}
                                {selected?.some(g => g === item.id) && <CheckedSvg />}
                            </div>
                            <div className="item-text">{`名称：${item?.name || ''}`}</div>
                            <div className="item-text">{`职位：${item?.positionName || '无'}`}</div>
                            <div className="item-text">{`单位：${item?.enterprise || '无'}`}</div>
                        </div>
                    ))}
                </div>
            </Spin>
        </MonixModal>
    )
}